import icEdit04Primary from "assets/images/ic-edit-04-primary.svg";
import icEyeOpen from "assets/images/ic-eye-open.svg";
import icTrash01Red from "assets/images/ic-trash-01-red.svg";
import moment from "moment";
import Button from "../../components/commons/button";
import { ACTION_TYPE } from "../../constants/constant";
import { formatDateMoment } from "../../utils/utils";


export const TABLE_EVENT_SETTING = {
    name: 'Event',
    column: [
        {
            name: "Tanggal Event",
            key: "date",
            className: "font-bold capitalize",
            render: ({value}) => <div>{formatDateMoment(value, 'D MMMM YYYY')}</div>
        },
        {
            name: "Judul Event",
            key: "name",
            className: "font-bold capitalize",
        },
        {
            name: "Created By",
            key: "actor",
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({ item, onClickItem }) => (
                <div className="flex space-x-3 justify-center">
                    <Button 
                        className="w-[80px]" 
                        type="outline"
                        icon={icEyeOpen} 
                        title="Preview" 
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.PREVIEW })}
                    />
                    <Button
                        type="outline"
                        icon={icEdit04Primary}
                        disabled={moment(item?.date).isBefore(moment(), "day")}
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.EDIT})}
                    />
                    <Button
                        type="danger"
                        icon={icTrash01Red}
                        disabled={moment(item?.date).isBefore(moment(), "day")}
                        onClick={() => onClickItem({id: item?.id, actionType: ACTION_TYPE.DELETE})}
                    />
                </div>
            )
        }
    ]
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
